<template lang="pug">
  .exchange-list-skeleton-container
    .exchange-list-skeleton-header
      SkeletonItem(className='exchange-list-skeleton-header-title')
      SkeletonItem(className='exchange-list-skeleton-header-tabs')
    .exchange-list-skeleton-cards
      .exchange-list-skeleton-card(v-for="i in 6")
        SkeletonItem(className='exchange-list-skeleton-card-img')
        SkeletonItem(className='exchange-list-skeleton-card-btn')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'ExchangeListSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.exchange-list-skeleton-container {
  width: 100%;

  .exchange-list-skeleton-header {
    padding: 0.18rem 0.2rem 0;
    height: 0.94rem;
    background-image:
      linear-gradient(
        180deg,
        #fff 0%,
        #fcfcfd 81.25%,
        #f0f3f5 100%
      );
    border-radius: 0.16rem 0.16rem 0 0;
    box-sizing: border-box;
  }

  .exchange-list-skeleton-header-title {
    width: 1.38rem;
    height: 0.22rem;
  }

  .exchange-list-skeleton-header-tabs {
    margin-top: 0.16rem;
    width: 0.88rem;
    height: 0.13rem;
  }

  .exchange-list-skeleton-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 0 0.16rem;
    gap: 0.12rem 0.16rem;
  }

  .exchange-list-skeleton-card {
    width: 1.64rem;
    height: 1.85rem;
    box-sizing: border-box;
    border: 0.01rem solid #fff;
    border-radius: 0.12rem;
    background-color: #fff;

    .exchange-list-skeleton-card-img {
      width: 100%;
      height: 0.98rem;
      border-radius: 0.12rem 0.12rem 0 0;
    }

    .exchange-list-skeleton-card-btn {
      margin: 0.48rem 0 0 1.04rem;
      width: 0.47rem;
      height: 0.24rem;
      border-radius: 0.2rem;
    }
  }
}
</style>
